import {
  FormValidator,
  type FormValidatorConfig,
  type FormValidatorContext,
  type FormValidatorSettings
} from '@common';
import { toRaw } from 'vue';
import { isWithinDays } from '@core';
import { PeriodBoundary } from '../../../models';

export interface HeightmapDataPeriodDateValidatorSettings extends FormValidatorSettings {
  otherFieldName: string;
  periodBoundary: PeriodBoundary;
  invalidEndDateMessage?: string;
  invalidStartDateMessage?: string;
}

export type HeightmapDataPeriodDateValidatorConfig = FormValidatorConfig<HeightmapDataPeriodDateValidatorSettings>;

export class HeightmapDataPeriodDateValidator extends FormValidator<HeightmapDataPeriodDateValidatorSettings> {
  constructor() {
    super();
    this._name = 'heightmapDataPeriodDate';
    this._settings = {
      needTranslate: true,
      otherFieldName: '',
      periodBoundary: PeriodBoundary.START,
      invalidEndDateMessage: 'heightmap.validator.heightmapDataPeriodDate.invalidEndDateMessage',
      invalidStartDateMessage: 'heightmap.validator.heightmapDataPeriodDate.invalidStartDateMessage',
      invalidMessage: ''
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    const values = toRaw(context.values);
    const settings = this.settings;
    const otherValue = values[settings.otherFieldName];

    const startDate = settings.periodBoundary === PeriodBoundary.START ? parseDate(value) : parseDate(otherValue);
    const endDate = settings.periodBoundary === PeriodBoundary.START ? parseDate(otherValue) : parseDate(value);

    this._valid = Boolean(startDate && endDate && isWithinDays(startDate, endDate, 7));

    if (!this._valid) {
      const msg =
        settings.periodBoundary === PeriodBoundary.START
          ? settings.invalidStartDateMessage
          : settings.invalidEndDateMessage;
      this.addMessage(msg ?? '');
    }
  }
}

const parseDate = (value: any) => (value ? new Date(value) : null);
